// @flow
import React, { Component } from 'react';
import { View, StyleSheet } from 'react-native';
import RadioButton from './RadioButton';
import I18n from '../../../../lib/i18n';
import type { InputProps } from 'redux-form';

export default class IdTypeRadioButtons extends Component<Props> {
  styles = getStyles();

  selectIdCard = () => {
    this.props.input.onChange('IDENTITY_CARD');
  };
  selectPassport = () => {
    this.props.input.onChange('PASSPORT');
  };

  render() {
    const { disabled, style, input } = this.props;
    const styles = this.styles;
    const isIdType = input.value === 'IDENTITY_CARD';

    return (
      <View style={styles.container}>
        <RadioButton
          disabled={disabled}
          isActive={isIdType}
          label={I18n.t('SignUp.ConfirmPersonalInfo.idCard')}
          onSelect={this.selectIdCard}
          style={style}
        />
        <RadioButton
          disabled={disabled}
          isActive={!isIdType}
          label={I18n.t('SignUp.ConfirmPersonalInfo.passport')}
          onSelect={this.selectPassport}
          style={style}
        />
      </View>
    );
  }
}

const getStyles = () =>
  StyleSheet.create({
    container: {
      flexDirection: 'row',
    },
  });

type Props = {
  input: InputProps,
  style: Object,
  disabled: boolean,
};
